










import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class NextPage extends Vue {

  public data = {
    rose: {
      url: '/nos-parties-prenantes',
      title: 'Nos parties prenantes',
      text: 'Découvrez comment en 2021 nous avons chouchouté nos parties prenantes au quotidien',
    },
    vert: {
      url: '/gouvernance',
      title: 'Gouvernance',
      text: 'Découvrez comment en 2021 nous nous sommes efforcés d\'incarner notre vision',
    },
    orange: {
      url: '/value',
      title: 'Création de valeur(s)',
      text: 'Découvrez comment en 2021 nous avons généré de la valeur',
    },
  };

  @Prop() private color!: string;
}
